import Alpine from 'alpinejs'
import Swiper from 'swiper';
import "swiper/css";

const data = (params = {}) => ({
  /**
   * Data
   */
  loop: true,
  autoplayDelay: 0,
  swiper: null,
  swiperClass: 'swiper',
  autoplayInterval: null,
  activeIndex: 0,

  /**
   * Main
   */
  init() {
    if(window.innerWidth < 768) {
      this.swiper = new Swiper(`.${this.swiperClass}`,{
        loop: this.loop,
        slidesPerView: 1
      })

      this.startAutoplay();
      this.swiper.on('slideChangeTransitionStart', () => {
        this.activeIndex = this.swiper.realIndex;
        this.startAutoplay();
      });
    }
  },

  startAutoplay() {
    this.clearAutoplay();
    this.toggleScaleAnimation();
    const activeSlide = this.$el.querySelector('.swiper-slide-active');
    const contentType = activeSlide.dataset.content_type
    if (contentType == 'image') {
      this.autoplayInterval = setInterval(() => {
        this.swiper.slideNext();
      }, this.autoplayDelay);
    } else {
      this.setupVideo(activeSlide)
    }
  },

  setupVideo(activeSlide){
    const video = activeSlide.querySelector('video')
    video.pause();
    video.currentTime = '0';
    video.play();
    video.onended = () => {
      this.swiper.slideNext();
    };
  },

  clearAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  },

  toggleScaleAnimation() {
    const items = this.$el.querySelectorAll('.image_item');
    items.forEach(slide => slide.classList.remove('scale-animation'));
    const activeSlide = this.$el.querySelector('.swiper-slide-active');
    if (activeSlide) {
      const image = activeSlide.querySelector('.image_item')
      if (image) {
        image.classList.add('scale-animation');
      }
    }
  },

  slideNext (){
    this.swiper.animating = false
    this.swiper.slideNext()
    this.toggleNestedCaoursel()
  },
  
  clickToSlide(index){
    this.swiper.slideToLoop(index)
  },

  ...params
})

Alpine.data('BannerCarousel', data)
export default data
